import React from 'react';
import { connect } from 'react-redux';
import View from './views';
import API from '../../requests';
import FireboardUtils from '../../util/fireboard-util';
import { getPopupConfig } from '../../components/Popup';
import tableMergeEnum from '../../enums/tableMergeEnum';

class TableMerge extends React.Component {

  state = {
    popup: undefined,
    stations: [],
    parentStation: undefined,
    childStations: new Map(),
    onlyMergedTable: false,
    onlySensorTables: false,
  };

  stationsWithSensors = [];

  stationsDataWithSensors = [];

  componentDidMount() {
    this.getMergedTables();
    this.getSensorStations();
  }

  getMergedTables = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    this.getPopup('spinner', 'Fetching merged tables', null);
    API.getMergedTables({ storeId })
      .then(response => {
        const stations = response.data;
        stations.sort(this.sortFunction);
        this.setState({
          stations,
          popup: undefined,
        });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => {
        this.getErrorPopup(error);
      });
  };

  getSensorStations = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { sensors } = storeInfo?.data || {};
    sensors.forEach(eachSensor => {
      if (eachSensor.stationId && !this.stationsWithSensors.includes(eachSensor.stationId)) {
        this.stationsWithSensors.push(eachSensor.stationId);
      }
    });
  };

  pad = (num, size) => {
    let str = String(num);
    while (str.length < (size || 10)) {
      str = '0' + str;
    }
    return str;
  };

  sortFunction = (a, b) => {
    const name1 = this.pad(a.name ? a.name : '', 10).toLowerCase();
    const name2 = this.pad(b.name ? b.name : '', 10).toLowerCase();
    if (name1 < name2) {
      return -1;
    }
    if (name1 > name2) {
      return 1;
    }
    return 0;
  };

  setParentStation = (station, actionType, source, parentTable) => {
    switch (actionType) {
      case tableMergeEnum.MERGE:
        if (source === tableMergeEnum.CHILD) break;
        const { parentStation, childStations } = this.state;
        childStations.clear();
        if (parentStation && parentStation.id === station?.id) {
          this.setState({ parentStation: undefined, childStations });
        } else {
          this.setState({ parentStation: station, childStations });
        }
        break;
      case tableMergeEnum.UNMERGE:
        this.onUnMerge(station, source, parentTable);
        break;
      default:
        console.warn('case not handled...');
        break;
    }
  };

  setChildStation = station => {
    const { childStations } = this.state;
    if (childStations.has(station.id)) {
      childStations.delete(station.id);
    } else {
      childStations.set(station.id, station);
    }
    this.setState({ childStations });
  };

  onMerge = () => {
    const { parentStation, childStations } = this.state;
    let mergedStationIds = [];
    let mergedStationNames = [];
    childStations.forEach((value, key) => {
      mergedStationIds.push(key);
      mergedStationNames.push(value.name);
    });

    const callback = () => {
      const { reduxProps: { storeInfo } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      if (parentStation && parentStation?.id && mergedStationIds.length > 0) {
        const payload = {
          storeId,
          stationId: parentStation?.id,
          mergedStationIds: [...mergedStationIds]
        }
        this.getPopup('spinner', 'Merging tables', null);
        API.mergeTable(payload)
          .then(response => {
            this.resetStations(response.data);
          })
          .catch(error => {
            this.getErrorPopup(error);
          });
      }
    };

    const popup = getPopupConfig("error");
    popup.heading = 'Confirmation';
    popup.message = `This will merge table ${mergedStationNames} to ${parentStation?.name}. Would you like to continue?`;
    popup.buttons = [
      {
        text: 'CANCEL',
        onClick: this.closePopup,
      },
      {
        text: 'OK',
        onClick: () => {
          callback && callback();
        }
      },
    ];
    this.setState({ popup });
  };

  onUnMerge = (station, source, parentTable) => {
    const callback = () => {
      const { reduxProps: { storeInfo } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      const payload = {
        storeId,
        stationId: source === tableMergeEnum.CHILD ? parentTable?.id : station.id,
        mergedStationIds: source === tableMergeEnum.CHILD ? [station.id] : [],
      };
      this.getPopup('spinner', 'Unmerging tables', null);
      API.unMergeTable(payload)
        .then(response => {
          this.resetStations(response.data);
        })
        .catch(error => {
          this.getErrorPopup(error);
        });
    };

    const message = source === tableMergeEnum.CHILD
      ? `This will unmerge table ${station.name} from table ${parentTable.name}. Would you like to continue?`
      : `Selected table ${station.name} will be unmerged. Would you like to continue?`;
    const popup = getPopupConfig("error");
    popup.heading = 'Confirmation';
    popup.message = message;
    popup.buttons = [
      {
        text: 'CANCEL',
        onClick: this.closePopup,
      },
      {
        text: 'OK',
        onClick: () => {
          callback && callback();
        }
      },
    ];
    this.setState({ popup });
  };

  resetStations = stations => {
    const { childStations } = this.state;
    childStations.clear();
    stations.sort(this.sortFunction);
    this.stationsDataWithSensors = [];
    this.setState({
      stations,
      popup: undefined,
      parentStation: undefined,
      childStations,
    });
  }

  toggleMergedTables = event => {
    this.setState({ onlyMergedTable: event.target.checked });
  };

  toggleTableSensor = event => {
    this.setState({ onlySensorTables: event.target.checked });
  };

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === 'spinner'
        ? getPopupConfig('spinner')
        : getPopupConfig('error', () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  getErrorPopup = (error) => {
    const errorMsg = error.response
      ? error.response.data
      : error.message;
    FireboardUtils.addNetworkLogs(error.response);
    this.getPopup('error', null, errorMsg);
  };

  goBack = () => {
    const { history } = this.props;
    history && history.goBack();
  };

  getFilteredStationsWithSensors = () => {
    const { stations } = this.state;
    if (this.stationsDataWithSensors.length > 0) {
      return this.stationsDataWithSensors;
    }
    this.stationsDataWithSensors = stations.filter(each => this.stationsWithSensors.includes(each.id));
    return this.stationsDataWithSensors;
  }

  get viewProps() {
    const {
      popup,
      stations,
      parentStation,
      childStations,
      onlyMergedTable,
      onlySensorTables,
    } = this.state || {};

    const filteredStations = onlySensorTables ? this.getFilteredStationsWithSensors() : stations;

    return {
      popup,
      stations: filteredStations,
      parentStation,
      childStations,
      onlyMergedTable,
      goBack: this.goBack,
      closePopup: this.closePopup,
      onMerge: this.onMerge,
      setParentStation: this.setParentStation,
      setChildStation: this.setChildStation,
      toggleMergedTables: this.toggleMergedTables,
      sortFunction: this.sortFunction,
      onlySensorTables,
      toggleTableSensor: this.toggleTableSensor,
    };
  };

  render() {
    const viewProps = this.viewProps;
    return <View {...viewProps} />;
  }
}

const mapStateToProps = (reduxProps) => ({
  reduxProps,
});

export default connect(mapStateToProps, null)(TableMerge);
